<form *ngIf="configForm" [formGroup]="configForm" (ngSubmit)="onSubmit(configForm)">
  <mat-card class="content-card">
    <mat-card-header>
      <mat-card-title>
        <h5>Fee service config</h5>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-slide-toggle formControlName="feeGenerationEnabled">
        Fee generation enabled
      </mat-slide-toggle>
    </mat-card-content>
    <mat-card-actions align="end">
      <button mat-button type="submit" [disabled]="!configForm.valid || configForm.pristine">
        <mat-icon>done</mat-icon>
        <a>Save</a>
      </button>
    </mat-card-actions>
  </mat-card>
</form>